import { useState } from 'react';

export default function useToken() {

    const getToken = () => {
        const tokenString = sessionStorage.getItem('token');
        return JSON.parse(tokenString);
    };

    const [token, setToken] = useState(getToken());

    const saveToken = (userData) => {
        sessionStorage.setItem('token', JSON.stringify(userData.token));
        sessionStorage.setItem('permissions', JSON.stringify(userData.permissions || []));
        sessionStorage.setItem('userInfo', JSON.stringify({
            user_id: userData.user_id,
            username: userData.username,
            role: userData.role,
        }));
        setToken(userData.token);
    };

    return {
        setToken: saveToken,
        token,
    };
}

export function getPermissions() {
    try {
        return JSON.parse(sessionStorage.getItem('permissions') || '[]');
    } catch {
        return [];
    }
}

export function getUserInfo() {
    try {
        return JSON.parse(sessionStorage.getItem('userInfo') || '{}');
    } catch {
        return {};
    }
}

// hasPermission('schede', 'delete') → true/false
// hasPermission('schede') → controlla solo 'view'
export function hasPermission(sezione, azione = 'view') {
    return getPermissions().some(p => p.sezione === sezione && p.azione === azione);
}
